import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type FormNavigationProps = {
  onBack?: () => void;
  lastStep?: boolean;
  loading?: boolean;
  disabled?: boolean;
};

const FormNavigation = ({
  onBack,
  lastStep = false,
  loading = false,
  disabled = false,
}: FormNavigationProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Divider />
      <Grid
        container
        sx={[
          {
            justifyContent: 'space-between',
          },
          (theme) => ({
            marginTop: theme.spacing(spacingSizeMap.L),
          }),
        ]}
      >
        {onBack && (
          <Button variant="outlined" color="primary" onClick={onBack}>
            {t('ui.event-management.events.create.back-button')}
          </Button>
        )}
        <div />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading || disabled}
          endIcon={
            loading && (
              <CircularProgress
                size={24}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )
          }
        >
          {lastStep
            ? t('ui.event-management.events.create.create-event-button')
            : t('ui.event-management.events.create.next-button')}
        </Button>
      </Grid>
    </>
  );
};

export default FormNavigation;
